import Types from "./Types";

export const getMarkSchemesBySubjectRequest = (body) => ({
  type: Types.GET_MARK_SCHEMES_REQUEST,
  payload: body,
});

export const getMarkSchemesBySubjectSuccess = (data) => ({
  type: Types.GET_MARK_SCHEMES_SUCCESS,
  payload: data,
});

export const getMarkSchemesBySubjectFail = () => ({
  type: Types.GET_MARK_SCHEMES_FAIL,
});

export const addMarkSchemeLoading = (isLoading) => ({
  type: Types.ADD_MARK_SCHEMES_LOADING,
  payload: isLoading,
});

export const createMarkSchemeRequest = (formData, action) => ({
  type: Types.CREATE_MARK_SCHEME_REQUEST,
  payload: formData,
  action,
});

export const createMarkSchemeSuccess = ({ data }) => ({
  type: Types.CREATE_MARK_SCHEME_SUCCESS,
  payload: { data },
});

export const createMarkSchemeFail = () => ({
  type: Types.CREATE_MARK_SCHEME_FAIL,
});

export const registerMarkSchemeRequest = (body) => ({
  type: Types.REGISTER_MARK_SCHEME_REQUEST,
  payload: body,
});

export const registerMarkSchemeSuccess = (data) => ({
  type: Types.REGISTER_MARK_SCHEME_SUCCESS,
  payload: data,
});

export const registerMarkSchemeFail = () => ({
  type: Types.REGISTER_MARK_SCHEME_FAIL,
});
